module.exports = __webpack_public_path__ + "static/media/expert-facebook-icon.ffd4936a.svg";